import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'self-filer-field-view',
  templateUrl: './self-filer-field-view.component.html',
  styleUrls: ['./self-filer-field-view.component.scss'],
})
export class SelfFilerFieldViewComponent implements OnInit {
  @Input() public label: string;
  constructor() {}

  public ngOnInit(): void {}
}
